import React, { Component } from 'react';

class Sites extends Component {
	render(){
		const { theme } = this.props
		return (
			<div id="sites">
			   <a href="http://www.she.com/"title="she.com" className="fixed-menu-item Abel she" target="blank" style={{ display:( theme == 'she.com' ? 'none' : '') }} ><span>she.com</span></a>
			   <a href="http://www.shemom.com/"title="shemom.com" className="fixed-menu-item Abel shemom" target="blank" style={{ display:( theme == 'shemom.com' ? 'none' : '') }} ><span>shemom</span></a>
			   <a href="http://brides.she.com/" title="shebrides" className="fixed-menu-item Abel brides" target="blank" style={{ display:( theme == 'brides.she.com' ? 'none' : '') }}><span>shebrides</span></a>
			   {/*<a href="http://www.luxshery.com/" title="luxshery" className="fixed-menu-item Abel luxshery" target="blank" style={{ display:( theme == 'luxshery.com' ? 'none' : '') }}><span>luxshery</span></a>*/}
			   {/*<a href="http://k.she.com/" title="k channel" className="fixed-menu-item Abel kchannel" target="blank" style={{ display:( theme == 'k.she.com' ? 'none' : '') }}><span>k channel</span></a>*/}
			   <a href="http://critiques.she.com/beauty/" title="critiques" className="fixed-menu-item Abel critiques" target="blank" style={{ display:( theme == 'critiques.she.com' ? 'none' : '' )}}><span>critiques</span></a>
				<a href="http://shop.she.com/" title="sheblog" className="fixed-menu-item Abel sheshop" target="blank" style={{ display:theme == 'shop.she.com' ? 'none' : '' }}><span>sheshops</span></a>
				<a href="http://community.she.com" title="messageboard" className="fixed-menu-item Abel messageboard" target="blank" style={{ display:( theme == 'community.she.com' ? 'none' : '') }}><span>messageboard</span></a>
			   <a href="http://blog.she.com/" title="sheblog" className="fixed-menu-item Abel sheblog" target="blank" style={{ display:theme == 'blog.she.com' ? 'none' : '' }}><span>sheblog</span></a>

			</div>
		)
	}
}

export default Sites


// WEBPACK FOOTER //
// ./src/Sites.js